
import { Button, IconButton, Tooltip, Icon, Typography, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box } from "@mui/material";
import type { MovimentacaoObraFormWithNames } from "../../gerar-movimentacao-financeira";

interface Plano {
    id: number | string;
    code: string;
    description: string;
}

interface MovimentacoesAdicionadasProps {
    movimentacoes: MovimentacaoObraFormWithNames[];
    planos: Plano[];
    tiposMovimentacao: Record<string | number, string>;
    modalidade: Record<string, string>;
    mutate: (movs: MovimentacaoObraFormWithNames[]) => void;
    isPending: boolean;
    onRemoveMovimentacao: (idx: number) => void;
}

export function MovimentacoesAdicionadas({
    movimentacoes,
    planos,
    tiposMovimentacao,
    modalidade,
    mutate,
    isPending,
    onRemoveMovimentacao,
}: MovimentacoesAdicionadasProps) {
    return (
        <Box mt={2} sx={{ maxWidth: "100%", margin: "0 auto", px: 2 }}>
            {movimentacoes.length > 0 && (
                <>
                    <Typography variant="h6" mb={1}>
                        Movimentações a serem geradas:
                    </Typography>
                    <TableContainer component={Paper} sx={{ border: "1px solid #eee", width: "100%" }}>
                            <Table
                              size="small"
                              stickyHeader
                              sx={{
                                width: "100%",
                                '@media (max-width:1600px)': {
                                  width: '1920px',
                                },
                              }}
                            >
                            <TableHead>
                                <TableRow>
                                    <TableCell>Cliente</TableCell>
                                    <TableCell>Obra</TableCell>
                                    <TableCell>Funcionário</TableCell>
                                    <TableCell>Tipo</TableCell>
                                    <TableCell>Plano de Contas</TableCell>
                                    <TableCell>Quantidade</TableCell>
                                    <TableCell>Valor</TableCell>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Cálculo do sistema</TableCell>
                                    <TableCell>Nota Fiscal</TableCell>
                                    <TableCell align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {movimentacoes.map((mov, idx) => {
                                    const plano = planos.find((p) => p.id === mov.idChartOfAccounts);
                                    return (
                                        <TableRow key={idx}>
                                            <TableCell>{mov.clientName || "Não aplicável"}</TableCell>
                                            <TableCell>{mov.workName || "Não aplicável"}</TableCell>
                                            <TableCell>{mov.employeeName || "Não aplicável"}</TableCell>
                                            <TableCell>{tiposMovimentacao[mov.movementType] || "Outro"}</TableCell>
                                            <TableCell>
                                                {plano ? `${plano.code} - ${plano.description}` : "Outro"}
                                            </TableCell>
                                            <TableCell>
                                                {mov?.quantityToPay !== undefined && mov?.unit
                                                    ? `${mov.quantityToPay} ${modalidade[mov.unit]}`
                                                    : ""}
                                            </TableCell>
                                            <TableCell>
                                                {(mov.value && mov.value !== 0
                                                    ? mov.value
                                                    : mov?.custoFuncionario || 0
                                                ).toLocaleString("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL",
                                                    minimumFractionDigits: 2,
                                                })}
                                            </TableCell>
                                            <TableCell>{mov.dateMovement}</TableCell>
                                            <TableCell>
                                                {mov?.custoFuncionario?.toLocaleString("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL",
                                                    minimumFractionDigits: 2,
                                                }) || "Não aplicável"}
                                            </TableCell>
                                            <TableCell>
                                                {mov.isRelatedToNfs && mov.idNfs
                                                    ? mov.nfsNumber || mov.idNfs
                                                    : "Não relacionada"}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="Remover">
                                                    <IconButton size="small" onClick={() => onRemoveMovimentacao(idx)}>
                                                        <Icon>delete</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                mutate(movimentacoes);
                            }}
                            disabled={isPending}
                            size="small"
                        >
                            Gerar Todas
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    );
}